import { Route, createBrowserRouter, createRoutesFromElements, useRouteError } from 'react-router-dom';
import { Layout } from '$Components/layout/Layout';
import { React, s } from '../Imports';
import { useEffect } from 'react';
import { IApplicationProps } from '../Application';
import { IApplicationOptions } from '$Utilities/api';
import { HomePage } from '../pages/Home/Home';
import { EventReviewPage } from '../pages/EventReview';
import { EventExpiredPage } from '../pages/EventExpired';
import { DriverEventAcceptedPage } from '../pages/DriverEventAccepted';
import { DriverDiscussionSentPage } from '../pages/DriverDiscussionSent';

const ErrorBoundary = () => {
    const error = useRouteError();
    console.error('Router error:', error);

    return (
        <div role="alert">
            <h2>Oops! Something went wrong</h2>
            <p>There was an error loading this page.</p>
        </div>
    );
};

const PageTitleSetter: React.FC<{ title: string; setPageTitle: (title: string) => void; children: React.ReactNode }> = ({
    title,
    setPageTitle,
    children,
}) => {
    useEffect(() => {
        setPageTitle(title);
    }, [title, setPageTitle]);

    return <>{children}</>;
};

interface IRouterBaseProps {}

type IRouterProps = IRouterBaseProps & IApplicationProps;

export const useRouter = (props: IRouterProps) => {
    const apiOptions: IApplicationOptions = {
        // The current api generator can't handle "/" as a base url, so we replace that with a
        // fully qualified base URL with trailing slashes removed
        applicationRoot: props.baseUrl,
        apiBaseUrl: s.rtrim(`${props.apiBaseUrl}`, '/'),
        wrappedFetch: fetch,
    };

    const router = createBrowserRouter(
        createRoutesFromElements(
            <>
                <Route element={<Layout apiOptions={apiOptions} />} errorElement={<ErrorBoundary />}>
                    <Route
                        path="/"
                        element={
                            <PageTitleSetter title="Home" setPageTitle={props.setPageTitle}>
                                <HomePage />
                            </PageTitleSetter>
                        }
                    />

                    <Route
                        path="/eventreview"
                        element={
                            <PageTitleSetter title="Event Review" setPageTitle={props.setPageTitle}>
                                <EventReviewPage />
                            </PageTitleSetter>
                        }
                    />

                    <Route
                        path="/eventexpired"
                        element={
                            <PageTitleSetter title="Event Expired" setPageTitle={props.setPageTitle}>
                                <EventExpiredPage />
                            </PageTitleSetter>
                        }
                    />

                    <Route
                        path="/drivereventaccepted"
                        element={
                            <PageTitleSetter title="Driver Event Accepted" setPageTitle={props.setPageTitle}>
                                <DriverEventAcceptedPage />
                            </PageTitleSetter>
                        }
                    />

                    <Route
                        path="/driverdiscussionsent"
                        element={
                            <PageTitleSetter title="Driver Discussion Sent" setPageTitle={props.setPageTitle}>
                                <DriverDiscussionSentPage />
                            </PageTitleSetter>
                        }
                    />
                </Route>
            </>,
        ),
    );

    return { router };
};
